import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type AdminAnalyticsResponse = {
  dealsByStatus: Array<{ status: string; label: string; count: number }>;
  performance: Array<{
    id: string;
    company_name: string;
    tier: string | null;
    total: number;
    won: number;
    arr: number;
    intros: number;
  }>;
  topAssets: Array<{ title: string; type: string; views: number }>;
};

// GET /api/admin/analytics — workspace-aggregate analytics dashboard.
// Distinct from /api/portal/analytics/* (partner-scoped). The legacy
// /app/admin/analytics/page.tsx aggregated four parallel Supabase reads
// inline; the worker now collapses them into a single GET.
export function useAdminAnalytics() {
  return useQuery<AdminAnalyticsResponse, ApiClientError>({
    queryKey: queryKeys.admin.analytics(),
    queryFn: () => apiFetch<AdminAnalyticsResponse>("/admin/analytics"),
  });
}
